<script>
  import { onMount } from 'svelte';
  let isScrolled = false;
  let isMenuOpen = false;
  onMount(() => {
    window.addEventListener('scroll', () => {
      isScrolled = window.scrollY > 50;
    });
  });
  function toggleMenu() {
    isMenuOpen = !isMenuOpen;
  }
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (isMenuOpen) toggleMenu();
  }
</script>
<header class:scrolled={isScrolled}>
  <a href="https://wa.me/3534687621" target="_blank" class="whatsapp-button desktop-whatsapp">
    <img src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/3.0.1/whatsapp.svg" alt="WhatsApp" class="whatsapp-icon" />
    Contattami
  </a>
  <nav>
    <button class="menu-toggle" on:click={toggleMenu} aria-label="Toggle menu">
      <div class="hamburger">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </button>
    <ul class:open={isMenuOpen}>
      <li><a href="#" on:click|preventDefault={scrollToTop}>Home</a></li>
      <li><a href="#servizi">Servizi</a></li>
      <li><a href="#chi-sono">Chi sono</a></li>
      <li><a href="#contatti">Contatti</a></li>
    </ul>
  </nav>
</header>
<a href="https://wa.me/3534687621" target="_blank" class="whatsapp-button mobile-whatsapp">
  <img src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/3.0.1/whatsapp.svg" alt="WhatsApp" class="whatsapp-icon" />
  Contattami
</a>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600&display=swap');
  :global(body) {
    font-family: 'Nunito', sans-serif;
  }
  header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.3s ease;
  }
  header.scrolled {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  nav {
    display: flex;
    align-items: center;
  }
  .menu-toggle {
    display: none;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 10px;
  }
  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 18px;
  }
  .hamburger span {
    display: block;
    height: 3px;
    width: 100%;
    background-color: #cf7074;
    transition: all 0.3s ease;
  }
  ul {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  li {
    margin-left: 1.5rem;
  }
  a {
    text-decoration: none;
    color: black;
    font-size: 1.7rem;
    font-weight: 600;
    transition: color 0.3s ease;
  }
  a:hover {
    color: #cf7074;
  }
  .whatsapp-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(238,207,194,1);
    color: black;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 600;
    transition: background-color 0.3s ease;
  }
  .whatsapp-button:hover {
    background-color: #b85f63;
    color: black;
  }
  .whatsapp-icon {
    width: 24px;
    height: 24px;
    margin-right: 0.5rem;
  }
  .mobile-whatsapp {
    display: none;
  }
  @media (max-width: 768px) {
    header {
      justify-content: flex-end;
    }
    .menu-toggle {
      display: block;
    }
    ul {
      display: none;
      position: absolute;
      top: 100%;
      right: 0;
      background-color: rgba(238,207,194,1);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      padding: 0.5rem;
      min-width: 150px;
    }
    ul.open {
      display: flex;
      flex-direction: column;
    }
    li {
      margin: 0.25rem 0;
    }
    a {
      display: block;
      padding: 0.5rem;
      font-size: 1rem;
    }
    .desktop-whatsapp {
      display: none;
    }
    .mobile-whatsapp {
      display: flex;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      border-radius: 0;
      padding: 0.75rem;
    }
    .whatsapp-button:hover, .whatsapp-button:active, .whatsapp-button:focus {
      background-color: #ffced2;
      color: black;
    }
  }
</style>